export default {
  'pages.team.title': '公司列表',
  'pages.team.createForm.newTeam': '新建公司',
  'pages.team.createForm.teamName': '公司名称',
  'pages.team.createForm.teamName.required': '公司名称不能为空',
  'pages.team.createForm.teamDescription': '公司描述',

  'pages.account.setting': '个人设置',
  'pages.account.basesettings': '基本设置',
  'pages.account.security': '安全设置',
  'pages.account.rule.companyRequired': '请联系管理员获取公司信息！',
  'pages.account.rule.emailRequired': '请联系管理员获取邮箱信息！',

  //-- 报表API授权管理
  'pages.reportApi.menuMap.OB': 'OpenBrowser API',
  'pages.reportApi.menuMap.MP': 'MetaXTV API',
  'pages.reportApi.menuMap.AdSdk': 'AdSDK API',
  'pages.reportApi.menuMap.DistributionOwn': 'MetaX Platform API',
  'pages.reportApi.menuMap.DistributionThirdParty': 'Third Party Platform API',
  'pages.reportApi.applyToken.title': 'API授权',
  'pages.reportApi.applyToken.description': '点击按钮申请API Token授权',
  'pages.reportApi.applyToken.button': '申请Token',

  'pages.account.password': '账号密码',
  'pages.account.currently.email': '当前绑定邮箱',
  'pages.account.modifyPassword': '修改密码',
  'pages.account.modifyPassword.confirm': '确定要修改密码吗?',

  'pages.access.resendEmailVerification' : '重新发送邮箱验证通知',
  'pages.access.sendEmailVerificationCheck': '给该账户重新发送邮箱验证通知?',
  'pages.access.deleteUserCheck': '确定要删除该账户吗?',
  'pages.access.createForm.newUser': '新建用户',
  'pages.access.createForm.userName': '用户名',
  'pages.access.createForm.userName.required': '用户名不能为空',
  'pages.access.createForm.userEmail': '用户邮箱',
  'pages.access.createForm.userEmail.required': '用户邮箱不能为空',

};
